var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.261,
    height: 17.97,
    viewBox: "0 0 18.261 17.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#606060}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    transform: "translate(-12.406 -589.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2342",
    d: "M53.52 592.179a1.37 1.37 0 0 1-.057.229 3.421 3.421 0 0 1-.562 1Q49 597.74 45.026 602a2.934 2.934 0 0 1-.92.564c-.679.318-1.37.611-2.062.9a1.05 1.05 0 0 1-1.235-.144 1.031 1.031 0 0 1-.2-1.174c.286-.819.548-1.646.84-2.463a1.856 1.856 0 0 1 .38-.627q3.893-4.259 7.8-8.5a2.084 2.084 0 0 1 2.5-.616 2.166 2.166 0 0 1 1.391 2.239zm-1.535.129a.755.755 0 0 0 .057-.636c-.007-.018-.014-.035-.023-.052-.28-.563-.91-.588-1.421-.036q-3.035 3.28-6.058 6.573c-.788.856-.839.632.1 1.509.282.264.465.216.709-.051 2.14-2.341 4.293-4.671 6.433-7.011a1.573 1.573 0 0 0 .203-.296zm-9.721 8.848l.629.57.766-.349a.327.327 0 0 0 .073-.537l-.679-.613a.327.327 0 0 0-.522.146z",
    className: "cls-1",
    transform: "translate(-22.868)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2343",
    d: "M28.757 604.953v-.028a.7.7 0 0 0-1.384-.133 1.344 1.344 0 0 0-.046.583v5.886a2.067 2.067 0 0 1-2.248 2.274q-4.5.017-9 0a2.13 2.13 0 0 1-2.3-2.311c-.012-1.193 0-2.385 0-3.578 0-1.77-.015-3.54.006-5.309a2.1 2.1 0 0 1 2.256-2.228c.423-.005.846 0 1.27 0 1.731 0 3.463.015 5.193-.018a.781.781 0 0 0 .126-.015c.018 0 .035.005.053.005a.651.651 0 0 0 .605-.412.367.367 0 0 0 .032-.1.639.639 0 0 0-.04-.4.364.364 0 0 0-.071-.126l-.015-.013a.648.648 0 0 0-.5-.25 1.147 1.147 0 0 0-.24-.031c-2.193-.021-4.386-.035-6.578 0a3.389 3.389 0 0 0-3.451 3.549c-.01 1.5 0 3 0 4.5s.018 3 0 4.5a3.559 3.559 0 0 0 3.728 3.689c2.942.049 5.887.056 8.829 0a3.585 3.585 0 0 0 3.789-3.758c-.032-1.981-.006-3.963-.007-5.944-.019-.11.001-.232-.007-.332z",
    className: "cls-1",
    transform: "translate(0 -7.299)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2b78ba13287af6f39ffb780676e88982.svg";
export { ForwardRef as ReactComponent };